export const GET_ASSESSMENT_PAGE = 'GET_ASSESSMENT_PAGE';
export const FETCH_ASSESSMENT_PAGE_START = 'FETCH_ASSESSMENT_PAGE_START';
export const FETCH_ASSESSMENT_PAGE_SUCCESS = 'FETCH_ASSESSMENT_PAGE_SUCCESS';
export const FETCH_ASSESSMENT_PAGE_ERROR = 'FETCH_ASSESSMENT_PAGE_ERROR';

export const CHECK_CATEGORY_CHANGE = 'CHECK_CATEGORY_CHANGE';
export const CHECK_SELECTION = 'CHECK_SELECTION';
export const PAGE_CHANGE = 'PAGE_CHANGE';
export const SCALE_CHANGE = 'SCALE_CHANGE';
export const SET_EXTERNAL_ID = 'SET_EXTERNAL_ID';
export const SET_PREV_EXTERNAL_ID = 'SET_PREV_EXTERNAL_ID';
export const SET_QUALITY_CHECK_TABNAME = 'SET_QUALITY_CHECK_TABNAME';
export const TOGGLE_BORDERS_VISIBILITY = 'TOGGLE_BORDERS_VISIBILITY';
